'use client';

import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchGetSitePresetQuery } from '@module/queries/preset/presetQueryHooks';
import { spaAdvert } from '@module/utils/advert';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useMarketingTracker } from './marketing/useMarketingTracker';

/**
 * spa.js document append
 * path 변경 감지
 */
export default function CustomAdvert() {
  const { data: sitePreset } = useFetchGetSitePresetQuery();

  const pathname = usePathname();
  const { userInfo } = useGetLoginInfoQuery();
  const { initAll } = useMarketingTracker();

  // 초기 marketing 스크립트 설치 (DigitalCamp, Criteo)
  useEffect(() => {
    initAll();
  }, [initAll]);

  useEffect(() => {
    if (!sitePreset?.preset?.advertJs) return;
    const scriptList = document.getElementsByTagName('script');
    const alreadyExist = Array.from(scriptList).some((script) => {
      return script.src === sitePreset.preset?.advertJs;
    });

    if (alreadyExist) return;

    const script = document.createElement('script');
    script.src = sitePreset.preset?.advertJs;
    script.async = true;

    document.body.appendChild(script);
  }, [sitePreset]);
  // 성인 모드 적용 감지 - onetag 스크립트 삽입
  useEffect(() => {
    if (!userInfo) return;

    const SCRIPT_ID = 'onetag-tcs-script';
    const ADULT_EID = 'r1l7a5jhkew3r1l7a5jhke';
    const NON_ADULT_EID = '1iavf957bd06x1iavf957b';

    const eid = userInfo.isAdult ? ADULT_EID : NON_ADULT_EID;
    const scriptSrc = `https://cdn.onetag.co.kr/0/tcs.js?eid=${eid}`;

    // 기존 스크립트가 같은 src면 스킵
    const existingScript = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (existingScript?.src === scriptSrc) return;

    // 기존 스크립트 제거 (다른 eid일 경우)
    existingScript?.remove();

    // 새 스크립트 삽입
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = scriptSrc;
    script.async = true;
    document.head.appendChild(script);
  }, [userInfo, userInfo?.isAdult]);

  // 페이지 이동 감지
  useEffect(() => {
    if (!userInfo) return;
    spaAdvert('changePath', {
      path: pathname,
      userIdx: userInfo.idx,
    });
    if (typeof window !== 'undefined' && typeof window.callDM === 'function') {
      // https://enliple.notion.site/SPA-Single-Page-Application-SNS-1b9907ce77c78127a6a3d5deba68dc05 - 모비온 페이지 이동 데이터 획득
      window.callDM();
    }
  }, [pathname]);

  return null;
}
